import { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import { loginSide, logoIcon } from "../../../components/ui/media"
import { useForgotPassword } from "../../../hooks/useAuth"
import toast from 'react-hot-toast';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate()
  const forgotMutation = useForgotPassword()

  const checkEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  const handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (email.trim() == "" || !checkEmail(email)) {
      toast.error("Please put valid email address to proceed.")
      return false
    }
    const forgotData = {
      email
    }
    forgotMutation.mutate(forgotData, {
      onSuccess: (response) => {
        toast.success(response?.data?.message)
        setIsSubmitted(true);
      },
      onError: (error) => {
        const message = error.response?.data?.message || "Login failed"
        toast.error(message)
      }
    })
  };

  return (
    <div className="flex h-screen w-full bg-black text-white">
      {/* Left side with image and testimonial - same as login page */}
      <div className="relative w-1/2 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/70 z-10"></div>
        {/* Background image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${loginSide})`,
            filter: 'brightness(0.7) sepia(0.2)'
          }}>
        </div>
        {/* Decorative lights */}
        <div className="absolute inset-0 z-0">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className="absolute w-6 h-16 bg-amber-300/80 rounded-full blur-sm"
              style={{
                top: `${20 + (i * 15)}%`,
                left: `${15 + ((i % 3) * 30)}%`,
                boxShadow: '0 0 15px 5px rgba(251, 191, 36, 0.4)'
              }}>
            </div>
          ))}
        </div>
        {/* Logo */}
        <div className="absolute top-6 left-6 z-20 flex items-center">
          <span className="text-white font-semibold flex items-center">
            <img
              src={logoIcon}
              className="w-6 h-6 mr-2" />
            Newboo Inc
          </span>
        </div>
        {/* Testimonial */}
        <div className="absolute bottom-10 left-6 right-6 z-20">
          <p className="text-xl font-medium leading-relaxed mb-4">
            "This library has saved me countless hours of work and helped me deliver stunning designs to my clients faster than ever before."
          </p>
          <p className="text-sm">Sofia Davis</p>
        </div>
      </div>
      {/* Right side with forgot password form */}
      <div className="w-1/2 flex items-center justify-center bg-white">
        <div className="w-4/5 max-w-md p-6">
          {!isSubmitted ? (
            <>
              <div className="text-left mb-8">
                <h1 className="text-2xl font-bold text-gray-800 mb-2">Forgot Password</h1>
                <p className="text-gray-600">Enter your email below to create a new password to your account</p>
              </div>
              <div>
                <div className="mb-6">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter email"
                    className="w-full text-black px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <button
                  onClick={handleSubmit}
                  className="w-full bg-gray-800 text-white py-2 px-4 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 mb-6">
                  Send Link
                </button>
                <div className="flex items-center justify-start">
                  <button
                    onClick={() => navigate('/login')}
                    className="flex items-center text-gray-600 hover:text-gray-800">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-4 h-4 mr-2">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    Back
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div className="w-100 text-center bg-white p-6 rounded-lg shadow-xl border border-gray-100">
              <p className="text-gray-800 mb-2">
                Your email to reset your account password has successfully been sent to your "{email}".
              </p>
              <div className="flex justify-between mt-5">
                <button
                  onClick={() => navigate('/login')}
                  className="flex text-sm items-center text-gray-600 hover:text-gray-800">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-4 h-4 mr-2">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  Back to Login
                </button>
                <button
                  onClick={handleSubmit}
                  className="text-sm flex items-center text-gray-600 hover:text-gray-800">
                  Link Not Received? Resend
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;